
export default function IconOnlineEvent() {
  return (
    <svg
      enableBackground="new 0 0 512 512"
      height="40"
      viewBox="0 0 512 512"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m192.8 192.8c0-35.467-28.8-64.267-64.267-64.267-85.15 3.188-85.127 125.358.001 128.534 35.466 0 64.266-28.8 64.266-64.267z"></path>
        <path d="m32.133 417.733h130.667c0-35.491-28.775-64.267-64.267-64.267h-66.4c-42.586 1.594-42.556 62.7 0 64.267z"></path>
        <path d="m497 447.733h-482c-8.284 0-15 6.716-15 15v34.267c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15v-34.267c0-8.284-6.716-15-15-15z"></path>
        <path d="m98.533 323.467c51.979 0 94.267 42.288 94.267 94.267h18.632l30.734-92.202c-47.214-90.934-180.686-90.616-227.5.452 5.545-1.628 11.403-2.517 17.468-2.517z"></path>
        <path d="m287.836 283.39-44.781 134.344h226.557l41.619-124.856c1.524-4.574.758-9.603-2.062-13.514-2.819-3.912-7.348-6.229-12.169-6.229h-194.934c-6.456-.002-12.188 4.13-14.23 10.255zm79.564 62.043h16.066c19.881.738 19.866 29.269 0 30h-16.066c-19.88-.738-19.865-29.269 0-30z"></path>
        <path d="m464.866 0h-160.666c-26.338 0-47.134 21.39-47.134 47.133v128.533c0 26.266 21.307 47.133 47.134 47.133h1.066v-15c0-29.743 16.475-55.698 40.77-69.257-22.053-30.409.652-74.636 38.497-74.276 37.841-.361 60.555 43.875 38.497 74.276 24.295 13.559 40.769 39.514 40.769 69.257v15h1.066c26.338 0 47.134-21.39 47.134-47.133v-128.533c.001-26.337-21.389-47.133-47.133-47.133z"></path>
        <path d="m401.667 111.4c0-9.447-7.687-17.133-17.134-17.133-22.698.861-22.692 33.409 0 34.267 9.447-.001 17.134-7.687 17.134-17.134z"></path>
        <path d="m335.267 207.8v15h10.921l27.739 27.74c5.584 5.81 15.628 5.81 21.213 0l27.74-27.74h10.92v-15c-2.485-65.286-96.072-65.236-98.533 0z"></path>
      </g>
    </svg>
  );
}
